<template>
  <v-container fluid class="select-cards">
    <page-title title="Select Cards"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <v-layout column fill-height align-center justify-center>
      <v-progress-circular
        indeterminate=""
        v-if="loading"
      ></v-progress-circular>
      <v-btn
          class="preview-button"
          round=""
          outline=""
          depressed=""
          :href="
            '/preview-manager/proof/' +
              this.$store.getters['user/currentCampaign'].id
          "
          target="_blank"
        >
          <img :src="require('@/assets/play.svg')" />
          Preview
        </v-btn>
      

      <v-flex class="select-templates pa-0" v-if="!loading">
        <div class="select-templates-label">
          Select social proof templates for {{ view }} feedback
        </div>
        <v-layout align-center column>
          <v-flex
            class="template"
            v-for="(template, $index) in getTemplates(view)"
            :key="$index"
          >
            <v-layout align-center
              ><v-flex>
                <ProofWidget
                  :campaign="campaign"
                  :message="template"
                ></ProofWidget> </v-flex
              ><v-flex class="ml-4"
                ><v-layout column>
                  <v-switch
                    v-model="template.enabled"
                    class="lg-switch"
                    :ripple="false"
                    @change="selectionChange(template)"
                  ></v-switch>
                  <div>
                    This card is shown when you get {{ template.number }}/{{
                      template.numberOutOf
                    }}
                    rating for {{ view }}
                  </div></v-layout
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
import ProofWidget from '../../../../widgets/feedback/src/components/proof/ProofWidget'
import strings from '@/strings'
import proofApi from '@/api/proof'
export default {
  name: 'SelectCards',
  components: { Tabs, ProofWidget },
  created() {
    const vm = this
    this.setView()
    proofApi
      .getSettings(this.$router.currentRoute.params.campaignId)
      .then(function(res) {
        vm.settings = res.data.results
        vm.campaign = vm.$store.getters['user/currentCampaign']
        vm.campaign.proof = res.data.results
        vm.loading = false
      })
      .catch(function(res) {
        vm.loading = false
      })
  },
  data() {
    return {
      view: 'NPS',
      segment: '',
      labelTypeEnabled: true,
      ratingTypeEnabled: true,
      loading: true,
      settings: null
    }
  },
  computed: {
    tabSettings: function() {
      const tabs = []
      const enabledMetrics = this.$store.getters['campaign/enabledMetrics']
      if (enabledMetrics.indexOf('NPS') > -1) {
        tabs.push({
          id: routes.PROOF_CARDS_NPS,
          label: 'NPS'
        })
      }
      if (enabledMetrics.indexOf('CSAT') > -1) {
        tabs.push({
          id: routes.PROOF_CARDS_CSAT,
          label: 'CSAT'
        })
      }
      if (enabledMetrics.indexOf('CES') > -1) {
        tabs.push({
          id: routes.PROOF_CARDS_CES,
          label: 'CES'
        })
      }
      return {
        preselected: null,
        tabs: tabs
      }
    },
    segments() {
      if (this.view === 'NPS') {
        return [
          { id: 'PROMOTERS', label: 'Promoters' },
          { id: 'PASSIVES', label: 'Passive' }
        ]
      } else if (this.view === 'CSAT') {
        return [
          { id: 5, label: strings.SAT.widget_button_labels[4].label },
          { id: 4, label: strings.SAT.widget_button_labels[3].label }
        ]
      } else if (this.view === 'CES') {
        return [
          { id: 5, label: strings.ES.widget_button_labels[4].label },
          { id: 4, label: strings.ES.widget_button_labels[3].label }
        ]
      }
    }
  },
  watch: {
    $route() {
      this.setView()
    }
  },
  methods: {
    setView() {
      if (this.$router.currentRoute.name === routes.PROOF_CARDS_NPS) {
        this.view = 'NPS'
      } else if (this.$router.currentRoute.name === routes.PROOF_CARDS_CSAT) {
        this.view = 'CSAT'
      } else if (this.$router.currentRoute.name === routes.PROOF_CARDS_CES) {
        this.view = 'CES'
      }
    },
    getTemplates() {
      const dt = (new Date().getTime() - 288000000)/1000
      if (this.view === 'NPS' && this.settings) {
        return [
          {
            cords: [48.208176, 16.373819],
            id: 'c0135f59-9731-4c23-a6a7-733249712699',
            location: 'Paris',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>10/10</span>`,
            message_type: 'NPS_RATING',
            number: 10,
            numberOutOf: 10,
            time: dt,
            metric_type: 'NPS',
            user: 'Garrett from Paris',
            enabled: this.settings.nps_settings['10'].rating_enabled
          },
          {
            cords: [48.208176, 16.373819],
            id: '2175601b-600f-488b-af2b-f7296746823c',
            location: 'Vienna',
            message: `Highly recommends <span class='lgrm-brand-name'> ${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'NPS_LABEL',
            number: 10,
            numberOutOf: 10,
            time: dt,
            metric_type: 'NPS',
            user: 'Kelsey from Johannesburg',
            enabled: this.settings.nps_settings['10'].label_enabled
          },
          {
            cords: [48.208176, 16.373819],
            id: 'c0135f59-9731-4c23-a6a7-733249712699',
            location: 'London',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>9/10</span>`,
            message_type: 'NPS_RATING',
            number: 9,
            numberOutOf: 10,
            time: dt,
            metric_type: 'NPS',
            user: 'Heather from London',
            enabled: this.settings.nps_settings['9'].rating_enabled
          },
          {
            cords: [48.208176, 16.373819],
            id: '2175601b-600f-488b-af2b-f7296746823c',
            location: 'Vienna',
            message: `Highly recommends <span class='lgrm-brand-name'> ${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'NPS_LABEL',
            number: 9,
            numberOutOf: 10,
            time: dt,
            metric_type: 'NPS',
            user: 'John from Berlin',
            enabled: this.settings.nps_settings['9'].label_enabled
          },
          {
            cords: [48.208176, 16.373819],
            id: 'c0135f59-9731-4c23-a6a7-733249712699',
            location: 'Vienna',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>8/10</span>`,
            message_type: 'NPS_RATING',
            number: 8,
            numberOutOf: 10,
            time: dt,
            metric_type: 'NPS',
            user: 'User from Vienna',
            enabled: this.settings.nps_settings['8'].rating_enabled
          },
          {
            cords: [48.208176, 16.373819],
            id: '2175601b-600f-488b-af2b-f7296746823c',
            location: 'Vienna',
            message: `Recommends <span class='lgrm-brand-name'> ${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'NPS_LABEL',
            number: 8,
            numberOutOf: 10,
            time: dt,
            metric_type: 'NPS',
            user: 'User from Budapest',
            enabled: this.settings.nps_settings['8'].label_enabled
          }
        ]
      } else if (this.view === 'CSAT') {
        return [
          {
            cords: [53.480759, -2.242631],
            id: 'a104a265-77b5-4030-89dc-5936afc3cbd3',
            location: 'Manchester',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>5/5</span> for overall satisfaction`,
            message_type: 'SAT_RATING',
            number: 5,
            numberOutOf: 5,
            time: dt,
            metric_type: 'SAT',
            user: 'Garrett from Manchester',
            enabled: this.settings.csat_settings['5'].rating_enabled
          },
          {
            cords: [6.797717, 79.895045],
            id: '6c31d41c-a73e-476a-80cd-4cd416196641',
            location: 'Colombo',
            message: `Extremely satisfied with <span class='lgrm-brand-name'>${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'SAT_LABEL',
            number: 5,
            numberOutOf: 5,
            time: dt,
            metric_type: 'SAT',
            user: 'Heather from Colombo',
            enabled: this.settings.csat_settings['5'].label_enabled
          },
          {
            cords: [53.480759, -2.242631],
            id: 'a104a265-77b5-4030-89dc-5936afc3cbd3',
            location: 'Manchester',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>4/5</span> for overall satisfaction`,
            message_type: 'SAT_RATING',
            number: 4,
            numberOutOf: 5,
            time: dt,
            metric_type: 'SAT',
            user: 'Kelsey from Manchester',
            enabled: this.settings.csat_settings['4'].rating_enabled
          },
          {
            cords: [6.797717, 79.895045],
            id: '6c31d41c-a73e-476a-80cd-4cd416196641',
            location: 'Colombo',
            message: `Very satisfied with <span class='lgrm-brand-name'>${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'SAT_LABEL',
            number: 4,
            numberOutOf: 5,
            time: dt,
            metric_type: 'SAT',
            user: 'John from Colombo',
            enabled: this.settings.csat_settings['4'].label_enabled
          }
        ]
      } else if (this.view === 'CES') {
        return [
          {
            cords: [45.440845, 12.315515],
            id: '4bfeaf89-5fa8-4665-9e9e-2f44b6338b45',
            location: 'Manchester',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>5/5</span> for ease of use`,
            message_type: 'ES_RATING',
            number: 5,
            numberOutOf: 5,
            time: dt,
            metric_type: 'ES',
            user: 'Heather from Manchester',
            enabled: this.settings.ces_settings['5'].rating_enabled
          },
          {
            cords: [45.440845, 12.315515],
            id: 'd9e1cf0c-63ca-4113-a0e4-08e7eb2f7956',
            location: 'Colombo',
            message: `Testifies it is extremely easy to use <span class='lgrm-brand-name'>${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'ES_LABEL',
            number: 5,
            numberOutOf: 5,
            time: dt,
            metric_type: 'ES',
            user: 'Kelsey from Colombo',
            enabled: this.settings.ces_settings['5'].label_enabled
          },
          {
            cords: [45.440845, 12.315515],
            id: '4bfeaf89-5fa8-4665-9e9e-2f44b6338b45',
            location: 'Venice',
            message: `Rated ${this.$store.getters['user/currentCampaign'].brand_name} <span class='lgrm-rating-text'>4/5</span> for ease of use`,
            message_type: 'ES_RATING',
            number: 4,
            numberOutOf: 5,
            time: dt,
            type: 'ES',
            user: 'User from Venice',
            enabled: this.settings.ces_settings['4'].rating_enabled
          },
          {
            cords: [45.440845, 12.315515],
            id: 'd9e1cf0c-63ca-4113-a0e4-08e7eb2f7956',
            location: 'Venice',
            message: `Testifies it is very easy to use <span class='lgrm-brand-name'>${this.$store.getters['user/currentCampaign'].brand_name}</span>`,
            message_type: 'ES_LABEL',
            number: 4,
            numberOutOf: 5,
            time: dt,
            metric_type: 'ES',
            user: 'John from Venice',
            enabled: this.settings.ces_settings['4'].label_enabled
          }
        ]
      }
      return [
        {
          cords: [53.480759, -2.242631],
          id: 'a104a265-77b5-4030-89dc-5936afc3cbd3',
          location: 'Manchester',
          message:
            "Rated Loyagram <span class='lgrm-rating-text'>5/5</span> for overall satisfaction",
          message_type: 'SAT_RATING',
          number: 5,
          time: dt,
          metric_type: 'SAT',
          user: 'User from Manchester'
        }
      ]
    },
    selectionChange(settings) {
      console.log(settings)
      const vm = this
      if (vm.view === 'NPS') {
        if (settings.message_type === 'NPS_RATING') {
          this.settings.nps_settings[settings.number].rating_enabled =
            settings.enabled
        } else {
          this.settings.nps_settings[settings.number].label_enabled =
            settings.enabled
        }
      } else if (vm.view === 'CSAT') {
        if (settings.message_type === 'SAT_RATING') {
          this.settings.csat_settings[settings.number].rating_enabled =
            settings.enabled
        } else {
          this.settings.csat_settings[settings.number].label_enabled =
            settings.enabled
        }
      } else if (vm.view === 'CES') {
        if (settings.message_type === 'ES_RATING') {
          this.settings.ces_settings[settings.number].rating_enabled =
            settings.enabled
        } else {
          this.settings.ces_settings[settings.number].label_enabled =
            settings.enabled
        }
      }
      proofApi
        .saveSettings(
          this.$router.currentRoute.params.campaignId,
          this.settings
        )
        .then(function(res) {})
    }
  }
}
</script>

<style lang="stylus">
.select-cards {
    
    .select-templates{
        margin-top 10px
        .select-templates-label {
            margin-bottom 50px
            color: $color-primary-light-5
        }
        .lg-switch {
            margin-left 100px
        }
        .template {
            margin-bottom 50px
        }
    }

    .preview-button {
      background: #F5F9FD;
        border-color : $color-primary-light-5
        color: $color-primary-light-1
        width 120px
        font-weight normal
        font-size 14px
        position: fixed;
        top: 3px;
        z-index: 2;
        right: 3px;
        height 30px
        img {
          height 12px
        }
    }

    .lgrm-close {
        display none !important
    }

}
</style>
